import {
  Box,
  Badge,
  Button,
  Flex,
  Link,
  Spacer,
  Text,
  IconButton,
  useDisclosure,
  useTheme,
  VStack,
} from '@chakra-ui/react';
import { NavLink, useLocation } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { CJLogo } from './CJLogo';
import {
  USER_PERMISSIONS_NAMESPACE_KEY,
  READ_PROVIDER_MESSAGE_PERMISSION,
} from '../config';

const NavBar = ({ expandedView, ldFeatureFlags }) => {
  const { logout } = useAuth0();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const theme = useTheme();
  const { user } = useAuth0();
  const location = useLocation();
  const authorization = user?.[USER_PERMISSIONS_NAMESPACE_KEY];
  const isActiveRoute = (route) => {
    return location.pathname === route;
  };

  const PageTab = ({ path, text, isBeta }) => (
    <VStack mr={4} spacing={0}>
      <NavLink
        to={path}
        exact
        style={{
          textAlign: 'center',
          margin: '4px 8px',
          display: 'flex',
          alignItems: 'center',
        }}
        activeStyle={{ color: theme.colors.blueOne, fontWeight: '700' }}
      >
        {text}
        {isBeta && <BetaBadge />}
      </NavLink>
      {isActiveRoute(path) ? (
        <Box
          marginTop='0px'
          h='5px'
          borderRadius='5px'
          alignSelf='stretch'
          background={theme.colors.blueOne}
        />
      ) : (
        <Box
          marginTop='0px'
          h='5px'
          borderRadius='5px'
          alignSelf='stretch'
          background={theme.colors.white}
        />
      )}
    </VStack>
  );

  const BetaBadge = () => (
    <Badge
      bg='#3992C6'
      textColor='white'
      borderRadius='3px'
      fontSize='10px'
      lineHeight='12px'
      padding='2px 7px'
      ml={1}
    >
      Beta
    </Badge>
  );

  return (
    <Flex
      as='nav'
      align='center'
      justify='space-between'
      wrap='wrap'
      p={expandedView ? 1 : 3}
      bg='white'
      color='black'
      boxShadow='0px 17px 33px 0px rgba(0, 0, 0, 0.04)'
    >
      <Box>
        <CJLogo />
      </Box>
      {/* TODO: Use CJ home styles for the links */}
      <Box display='flex' alignItems='center' ml={12}>
        {/* <PageTab path='/' text='VBC Bot' /> */}
        {(authorization?.includes(READ_PROVIDER_MESSAGE_PERMISSION) ||
          !ldFeatureFlags?.chatAppUseRbac) && (
          <PageTab path='/providerBot' text='Provider Bot' isBeta={true} />
        )}
        <PageTab path='/glossary' text='Glossary' />
        <PageTab path='/admin' text='Admin' />
      </Box>

      <Spacer />

      <Box display='flex' alignItems='center'>
        <Text fontSize='sm' mr={4}>
          {user.name}
        </Text>
        <Button colorScheme='blue' onClick={logout}>
          Logout
        </Button>
      </Box>
    </Flex>
  );
};

export default NavBar;
